var VariantImage = /** @class */ (function () {
    function VariantImage(obj, id) {
        if (id) {
            this.id = id;
        }
        this.position = obj.position;
        this.image_url = obj.image_url;
    }
    Object.defineProperty(VariantImage.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariantImage.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariantImage.prototype, "ImageUrl", {
        get: function () {
            return this.image_url;
        },
        enumerable: false,
        configurable: true
    });
    return VariantImage;
}());
export { VariantImage };
export function createVariantImage(obj, id) {
    return new VariantImage(obj, id);
}
export function createVariantImages(rawVariantImages) {
    var variantImages = [];
    var rawVariantImagesData = rawVariantImages.data;
    for (var _i = 0, rawVariantImagesData_1 = rawVariantImagesData; _i < rawVariantImagesData_1.length; _i++) {
        var rawVariantImage = rawVariantImagesData_1[_i];
        var variantImage = createVariantImage(rawVariantImage.attributes, rawVariantImage.id);
        variantImages.push(variantImage);
    }
    return variantImages;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/product/variantImage.ts
// module id = 137
// module chunks = 0